// Uncomment the following lines to import the desired Bootstrap JavaScript components

// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

import './index.scss';

document.addEventListener('DOMContentLoaded', () => {
  const signInForm = document.querySelector('form[action*="login"]') as HTMLFormElement;
  const linkedInForm = document.querySelector('form[action*="lnkd_redirect"]') as HTMLFormElement;
  const termsCheckbox = document.getElementById('user_terms_of_service') as HTMLInputElement;

  if (!signInForm || !linkedInForm || !termsCheckbox) return;

  const validateTermsAcceptance = (event: Event): void => {
    if (!termsCheckbox.checked) {
      event.preventDefault();
      termsCheckbox.classList.add('is-invalid');
    }
  };

  const resetTermsAcceptance = (): void => {
    if (termsCheckbox.checked) termsCheckbox.classList.remove('is-invalid');
  };

  termsCheckbox.addEventListener('change', resetTermsAcceptance);
  signInForm.addEventListener('submit', validateTermsAcceptance);
  linkedInForm.addEventListener('submit', validateTermsAcceptance);
});
